import {
    Flex, theme, Typography,
} from 'antd';
import { TitleProps } from 'antd/es/typography/Title';
import {
    CSSProperties, useMemo,
} from 'react';

const titleStyle: CSSProperties = {
    marginTop: 0,
    marginBottom: 0,
    fontWeight: 700,
    lineHeight: 1,
};

const subtitleStyle: CSSProperties = {
    marginTop: 0,
    marginBottom: 0,
    fontWeight: 400,
};

type AppLogoProps = {
    size?: 'small' | 'medium' | 'large';
    isWhite?: boolean;
};

export const AppLogo = ({ size = 'medium', isWhite = false }: AppLogoProps) => {
    const { token } = theme.useToken();

    const titleLevel: TitleProps['level'] = useMemo(() => {
        switch (size) {
            case 'small':
                return 4;
            case 'medium':
                return 3;
            case 'large':
                return 2;
        }
    }, [size]);

    const subtitleFontSize: CSSProperties = useMemo(() => {
        switch (size) {
            case 'small':
                return { fontSize: 10 };
            case 'medium':
                return { fontSize: 12 };
            case 'large':
                return { fontSize: 14 };
        }
    }, [size]);

    return (
        <Flex vertical align="center">
            <Typography.Title level={titleLevel} style={{
                ...titleStyle,
                color: isWhite ? token.colorTextLightSolid : token.colorText,
            }}>
                PROSTO
            </Typography.Title>
            <Typography.Paragraph type="secondary" style={{
                ...subtitleStyle,
                ...subtitleFontSize,
                color: isWhite ? token.colorTextLightSolid : token.colorText,
            }}>
                (скрипти)
            </Typography.Paragraph>
        </Flex>
    );
};
